export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COMPANY = {
  name: "Syddansk Group",
  tagline: "Havepleje & hækklipning i Syddanmark",
  phone: "+4591100598",
  phoneDisplay: "91 10 05 98",
  email: "kontakt@syddanskgroup.dk",
  address: "Kolding, Syddanmark",
  areas: "Kolding · Haderslev · Aabenraa · Sønderborg · ned mod grænsen",
  cvr: "DK 42 56 75 23",
  hours: "Man–Fre 07:00–17:00 · Lør 08:00–14:00",
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
  },
};

// Hedge trimming calculator config
export const CALC = {
  basePricePerMeter: 32, // kr/m inkl. bortkørsel og rengøring
  wasteRemovalDiscount: 5, // fratrækkes hvis kunden selv fjerner affald
  heightOptions: [
    { value: "1_5_to_2_5", label: "1,5 – 2,5 meter", multiplier: 1.0 },
    { value: "over_2_5", label: "Over 2,5 meter", multiplier: 1.3 },
  ],
  additionalServices: [
    { id: "top_cut", label: "Topbeskæring", pricePerMeter: 8 },
    { id: "shape_cut", label: "Formklipning", pricePerMeter: 12 },
    { id: "stump_grind", label: "Stubfræsning (per stub)", flatPrice: 450 },
    { id: "cleanup_extra", label: "Ekstra oprydning af bede", flatPrice: 350 },
  ],
};
